import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  displayCardRoot: {
    display: 'flex',
    padding: '8px',
  },
  displayCardBackground: {
    backgroundColor: theme.new.color.background.input,
    borderRadius: '12px',
    border: `1px solid ${theme.new.color.line.hairline}`,
  },
  imageColumn: {
    minWidth: '60px',
    width: '60px',
    marginRight: '8px',
  },
  labelsColumn: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',

    '.MuiBox-root': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      width: '100%',
    },
  },
  closeIconColumn: {
    marginTop: '-6px',
    marginRight: '-2px',
    width: '20px',
    justifySelf: 'flex-end',
  },
  closeIconButton: {
    height: '16px',
    width: '16px',
    cursor: 'pointer',
    '&:hover': {
      path: {
        stroke: theme.new.color.brandPrimary,
      },
    },
  },
}));

export default useStyles;
